import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import clsx from 'clsx';

interface DialogActionsProps {
  onCancel: () => void;
  onConfirm: () => void;
  confirmText: string;
  cancelText?: string;
  isConfirmDisabled?: boolean;
  isConfirmLoading?: boolean;
  confirmColor?: 'primary' | 'danger';
  className?: string;
}

export const DialogActions = ({
  onCancel,
  onConfirm,
  confirmText,
  cancelText,
  isConfirmDisabled = false,
  isConfirmLoading = false,
  confirmColor = 'primary',
  className = '',
}: DialogActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className={clsx('flex justify-end gap-3', className)}>
      <Button
        onClick={onCancel}
        color="transparent"
        className="border-rw-main text-rw-neutral-darker-gray"
      >
        {cancelText || t('キャンセル')}
      </Button>
      <Button
        onClick={onConfirm}
        disabled={isConfirmDisabled}
        isLoading={isConfirmLoading}
        color={confirmColor}
      >
        {confirmText}
      </Button>
    </div>
  );
};
